export enum SocketEvent {
	NewMessage = "message:new",
	NewNotification = "notification:new",
	NewChats = "chats:new",
	DeletePatient = "patient:delete",
	MessagesRead = "messages:read",
}
